/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { ControlTable } from "../Table";
import { getParams } from "../../utils/params";
import { get } from "lodash";
import { consultingsExcelDownload, getConsultings, sendConsultinsEmailEnd, sendConsultinsEmailMidCheck } from "../../apis/admin/consulting";
import useForm from "../../hooks/useForm";
import Consulting from "./Consulting";
import AdMail from "../Mail/AdMail";
import { ANSWERED_STATUS } from "../../constants/CONSULTING";
import systemAlert from "../../utils/systemAlert";
import { toast } from "../../utils/toast";
import { forEach, isEmpty } from "lodash-es";
import { dateToFormat } from "../../utils/date";
import Filters from "../Filters";
import { COMPANY_TYPE } from "../../constants/COMPANY";
import { viewLoading } from "../../utils/loading";
import { downExcelFile } from "../../utils/download";
import { shallowEqual, useSelector } from "react-redux";
import ToolTip from "../ToolTip/ToolTip";
import Profile from "../Profile";


const Consultings = (props) => {
  const {
    hideButton,
    consultingType, // 상담신청 , 무료체험
    isMaster = false
  } = props;

  const { employee } = useSelector(store => ({
    employee: store.Profile.employee
  }), shallowEqual);


  const [fields] = useState([
    { title: "신청자", key: 'name' },
    { title: "요청세무사", key: 'company.name' },
    { title: "이메일", key: 'email' },
    { title: "회사 이름", key: 'companyName' },
    { title: "사업형태", key: 'businessType' }, // 개인사업자 | 법인사업자 | 기타세무상담
    { title: "직원수", key: 'employeeCount' },
    { title: "회사 타입", key: 'companyType', onValue: (v) => COMPANY_TYPE.find(f => f.value === v)?.label || "" },
    { title: "요청 날짜", label: '-', key: "createdTime", type: 'datetime' },

    // {title: "무료체험 | 상담신청" ,key:'consultingType'},
    // { title: "회사 하는일", key: 'aboutCompany' },
    // { title: "기타 메모", key: 'description' },
    {
      title: "담당자", key: 'replyEmployeeIdx', onValue: (data) => {
        return <Profile employeeIdx={data} emptyLabal={'없음'} />;
      }
    },
    {
      title: "답변여부", key: 'isAnswered', onValue: (data) => {
        if (!data) data = '대기중';
        const status = ANSWERED_STATUS.find(a => a.value === data);
        return status ?
          <span className={status.color}>{status.label}</span>
          : <span className={''}>{data}</span>;
      }
    },
    {
      title: "접근 url (통계용)", key: 'entryUrl',
      onValue: (v) => {
        return (
          <ToolTip tooltiptext={v} boxStyle={{ width: "auto" }}>
            <span className="ellipsis" style={{ width: "200px" }}>
              {v}
            </span>
          </ToolTip>
        );
      }
    },
    {
      isHide: consultingType !== '무료체험',
      type: 'button',
      size: 'x-sm',
      color: 'gray-line',
      // label: '중간점검',
      onValue: (value, field, data) => {
        return <>중간점검 {data.midCheckEmailTime ? <p>{dateToFormat(data.midCheckEmailTime, 'YYMMDD')}</p> : ''}</>;
      },
      onClick: ({ data }) => {
        systemAlert(`${data.name}님께 중간점검 메일을 전송하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                sendConsultinsEmailMidCheck({ consultingIdxes: [data.consultingIdx] }).then(() => {
                  toast.success(`${data.name}님께 중간점검 메일을 전송했습니다.`);
                });
              }
            }
          ]
        });
      }
    },
    {
      isHide: consultingType !== '무료체험',
      type: 'button',
      size: 'x-sm',
      color: 'gray-line',
      onValue: (value, field, data) => {
        return <>종료안내 {data.endEmailTime ? <p>{dateToFormat(data.endEmailTime, 'YYMMDD')}</p> : ''}</>;
      },
      onClick: ({ data }) => {
        systemAlert(`${data.name}님께 종료안내 메일을 전송하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                sendConsultinsEmailEnd({ consultingIdxes: [data.consultingIdx] }).then(() => {
                  toast.success(`${data.name}님께 종료안내 메일을 전송했습니다.`);
                });
              }
            }
          ]
        });
      }
    },
    {
      type: 'button',
      size: 'x-sm',
      color: 'gray-line',
      label: '상담 내역',
      onClick: ({ data }) => {
        setDetailOpen(true);
        setSelectedItem(data);
      }
    }
  ]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [isAdMail, setIsAdMail] = useState(false);
  const [formList, setFormList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      order: [
        {
          idx: "desc"
        },
      ],
      page: 0,
      limit: 10
    },
  );


  const _excelDownload = () => {

    systemAlert(`${employee?.name}님, ${consultingType} 목록 다운로드를 진행하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소',
        }, {
          label: '확인',
          onClick: () => {
            if (form?.search?.companyType) {
              if (form?.search?.companyType === "all") {
                delete form.search.companyType;
              } else {
                form.search.companyType = +form?.search?.companyType;
              }
            }


            const _params = getParams({
              ...form,
              search: {
                consultingType,
                ...form.search ? form.search : {}
              }
            });

            viewLoading("엑셀 다운로드 중입니다.");
            consultingsExcelDownload(_params).then((res) => {
              downExcelFile(res, `${consultingType}_목록.xlsx`);
              viewLoading(false);
            });
          }
        }
      ]
    });
  };

  const tableButtons = [
    {
      label: "AD메일보내기",
      color: 'gray-line',
      action: () => {
        setIsAdMail(true);
      },
    },
    {
      label: "중간점검 메일",
      color: 'gray-line',
      action: () => {
        let message = '';
        if (selectedList.length > 1) {
          message = `${selectedList[0].name} 외 ${selectedList.length - 1}명에게 중간점검 메일을 전송하시겠습니까?`;
        } else {
          message = `${selectedList[0].name}님께 중간점검 메일을 전송하시겠습니까?`;
        }

        systemAlert(`${message}`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                const body = {
                  consultingIdxes: []
                };
                forEach(selectedList, (s) => {
                  body.consultingIdxes.push(s.consultingIdx);
                });

                sendConsultinsEmailMidCheck(body).then(() => {
                  toast.success('중간점검 메일을 전송했습니다.');
                });
              }
            }
          ]
        });
      },
      disabled: isEmpty(selectedList)
    },
    {
      label: "종료안내 카카오톡알림",
      color: 'gray-line',
      action: () => {
        let message = '';
        if (selectedList.length > 1) {
          message = `${selectedList[0].name} 외 ${selectedList.length - 1}명에게 종료안내 카카오톡알림을 전송하시겠습니까?`;
        } else {
          message = `${selectedList[0].name}님께 종료안내 카카오톡알림을 전송하시겠습니까?`;
        }

        systemAlert(`${message}`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                const body = {
                  consultingIdxes: []
                };
                forEach(selectedList, (s) => {
                  body.consultingIdxes.push(s.consultingIdx);
                });

                sendConsultinsEmailEnd(body).then(() => {
                  toast.success('종료안내 카카오톡알림을 전송했습니다.');
                });
              }
            }
          ]
        });
      },
      disabled: isEmpty(selectedList)
    },
    {
      label: "엑셀 다운로드",
      color: "gray-line",
      action: _excelDownload,
      isHide: () => !isMaster
    },
    {
      label: "상담 추가 작성",
      action: () => {
        setDetailOpen(true);
        setFormList([]);
      },
    },
  ];

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const submit = (param) => {

    if (param?.search?.companyType) {
      if (param?.search?.companyType === "all") {
        delete param.search.companyType;
      } else {
        param.search.companyType = +param?.search?.companyType;
      }
    }

    if (!isEmpty(param.employee)) {
      param.replyEmployeeIdx = param.employee.map(e => e.idx)
    }

    getConsultings({
      ...getParams({
        ...param,
        search: {
          consultingType,
          ...param.search ? param.search : {}
        }
      }),

    })
      .then((res) => {
        setList([])
        setTimeout(() => {
          setIsLoading(false);
          setTotal(get(res, "data.total"));
          setList(get(res, "data.consultings"));
        }, 0)

      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  const [filters] = useState([
    {
      title: "기간",
      type: "CustomDatePicker",
      key: "range.createdTime",
    },
    {
      title: "답변",
      type: "select",
      key: "search.isAnswered",
      defaultValue: '',
      options: {
        list: [
          { label: "전체", value: '' },
          ...ANSWERED_STATUS
        ]
      },
    },
    {
      title: "상호",
      key: "search.companyName",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "신청자이름",
      key: "search.name",
      options: {
        placeholder: "검색어 입력",
      },
    },

    {
      title: "회사타입", key: "search.companyType",
      type: 'select',
      options: { list: [{ label: "전체", value: "all" }, ...COMPANY_TYPE.slice(0, COMPANY_TYPE.length - 1)] }
    },
    {
      title: "대상자",
      type: 'searchEmployees',
      key: "employee",
    }
  ]);

  return (
    <>

      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        buttons={hideButton ? [] : tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
      // isControl={false}
      />
      <Consulting
        open={detailOpen}
        setOpen={setDetailOpen}
        list={formList}
        submit={filterSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />

      <AdMail
        open={isAdMail}
        setOpen={setIsAdMail}
      />
    </>
  );
};

export default Consultings;